export default __webpack_public_path__ + "static/media/dangerCircle.5d29b817.svg";